import { render, staticRenderFns } from "./ModuleLessonEditor.vue?vue&type=template&id=899ea362&"
import script from "./ModuleLessonEditor.vue?vue&type=script&lang=js&"
export * from "./ModuleLessonEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports